import { render, staticRenderFns } from "./ProfileTalentBookings.vue?vue&type=template&id=2f4795c9"
import script from "./ProfileTalentBookings.vue?vue&type=script&lang=js"
export * from "./ProfileTalentBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports